import FontBody3 from "../../../../../../../components/fonts/font-body3/font-body3";
import { Toggle } from "../../../../../../../components/inputs/toggle/toggle";
import TableRow from "../../../../../../../components/table/components/table-row/table-row";
import "./address-editor-form-cell.scss";

type AddressEditorFormCellProps = {
    label: string;
    display: boolean;
    mandatory: boolean;

    onDisplayChange: (display: boolean) => void;
    onMandatoryChange: (mandatory: boolean) => void;

    isDisabled?: boolean;
    isAlwaysOptional?: boolean;
};

export const AddressEditorFormCell = ({
    label,
    display,
    mandatory,
    onDisplayChange,
    onMandatoryChange,
    isDisabled,
    isAlwaysOptional,
}: AddressEditorFormCellProps) => {
    const handleDisplayChange = (display: boolean) => {
        onDisplayChange(display);
        if (!display) {
            onMandatoryChange(false);
        }
    };

    const isMandatoryDisabled = !display || isDisabled || isAlwaysOptional;

    return (
        <TableRow
            skipWrapingCell={true}
            cells={[
                <FontBody3>{label}</FontBody3>,
                <div className="address-editor-form-toggle-wrapper">
                    <Toggle
                        checked={display}
                        label={""}
                        onChange={handleDisplayChange}
                        disabled={isDisabled}
                    />
                </div>,
                <div className="address-editor-form-toggle-wrapper">
                    <Toggle
                        checked={mandatory}
                        label={""}
                        onChange={onMandatoryChange}
                        disabled={isMandatoryDisabled}
                    />
                </div>,
            ]}
        />
    );
};
